/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
import XHeader from "vux/src/components/x-header/index.vue";
export default {
  components: {
    XHeader: XHeader
  },
  props: {
    value: {
      type: String,
      default: '物业管理'
    }
  },
  data: function data() {
    return {
      title: '会员中心'
    };
  },
  watch: {
    value: function value(val) {
      this.title = val;
    },
    title: function title(val) {
      this.$emit('input', val);
    }
  },
  mounted: function mounted() {
    if (this.value) {
      this.title = this.value;
    }
  },
  methods: {
    backHome: function backHome() {
      this.$router.push({
        name: 'Index'
      });
    }
  }
};